import { memo } from 'react';
import Slider from 'react-slick';
import { MATCH_STATUS } from '@zmedia/bm-soccer-ui/constants';
import { IMatch, IStatus } from '@zmedia/bm-soccer-ui/interface';
import { ArrayUtils, SoccerUtils } from '@zmedia/bm-soccer-ui/utils';
import { unixToDate } from '@zmedia/bm-soccer-ui/utils/date';
import {
    Element,
    IconButton,
    RouterLink,
    Section,
} from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { Team } from '../../team';
import { Status } from '../../status';
import { Score } from '../../score';
import styles from './style.module.scss';

const SlickButtonFix = ({
    currentSlide,
    slideCount,
    children,
    ...props
}: any) => <span {...props}>{children}</span>;

export function SliderMatchesHot(props: any) {
    const { items = [] } = props;

    if (ArrayUtils.isEmpty(items)) {
        return null;
    }

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 2,
        dots: false,
        infinite: true,
        speed: 500,
        variableWidth: true,
        draggable: false,
        swipe: true,
        nextArrow: (
            <SlickButtonFix>
                <IconButton
                    className={styles['btn-next']}
                    icon="forward-2"
                    title="Trước"
                ></IconButton>
            </SlickButtonFix>
        ),
        prevArrow: (
            <SlickButtonFix>
                <IconButton
                    className={styles['btn-prev']}
                    icon="back-2"
                    title="Sau"
                ></IconButton>
            </SlickButtonFix>
        ),
    };

    const _items = items.length % 2 === 0 ? items : items.slice(0, -1);

    return (
        <Section className={styles['match-hot-section']}>
            <Element className={styles['match-hot-list']}>
                <Slider {...settings}>
                    {_items?.map((item: IMatch, index: number) => {
                        return <MatchHotItem item={item} key={index} />;
                    })}
                </Slider>
            </Element>
        </Section>
    );
}

function MatchHotStatus({
    status,
    startTime,
    minuteLabel,
}: {
    status: IStatus;
    startTime?: number;
    minuteLabel?: string;
}) {
    const renderStatus = () => {
        switch (status.id) {
            case MATCH_STATUS.HT:
                return (
                    <Element renderAs="span" style={{ color: '#f00c' }}>
                        Hết hiệp 1
                    </Element>
                );
            case MATCH_STATUS.FT:
                const date = unixToDate(startTime, 'dddd, DD/MM');
                return (
                    <Element className={styles['end-match']}>
                        <Element className={styles['text']}>KT</Element>
                        <Element renderAs="time">{date}</Element>
                    </Element>
                );
            case MATCH_STATUS.LIVE:
            case MATCH_STATUS.PS:
            case MATCH_STATUS.ET:
                return (
                    <>
                        <Element className={styles['is-live']}></Element>
                        <Element renderAs="span">{minuteLabel}'</Element>
                    </>
                );
            case MATCH_STATUS.POSTPONED:
                return <>Hoãn</>;
            default:
                const date1 = unixToDate(startTime, 'HH:mm dddd, DD/MM');
                return <>{date1}</>;
        }
    };
    return <Status status={status}>{renderStatus()}</Status>;
}

function MatchHotItem({ item }: { item: IMatch }) {
    const { home, away, status, minuteLabel, startTime } = item;
    const isLive = SoccerUtils.isLiveMatch(status);
    const isNotStarted =
        status.id === MATCH_STATUS.NOT_STARTED ||
        status.id === MATCH_STATUS.POSTPONED;

    return (
        <RouterLink
            className={styles['match-hot-item']}
            to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
            tabIndex={-1}
            title={home.team.name + ' đấu với ' + away.team.name}
        >
            {isLive ? (
                <Score item={item} />
            ) : (
                <MatchHotStatus
                    status={status}
                    minuteLabel={minuteLabel}
                    startTime={startTime}
                />
            )}

            <Element className={styles['match-hot-team']}>
                <Team team={home.team} />
                {!(isNotStarted || isLive) && (
                    <Element className={styles['match-hot-score']}>
                        {home.score}
                    </Element>
                )}
            </Element>
            <Element className={styles['match-hot-team']}>
                <Team team={away.team} />
                {!(isNotStarted || isLive) && (
                    <Element className={styles['match-hot-score']}>
                        {away.score}
                    </Element>
                )}
            </Element>
        </RouterLink>
    );
}
export default memo(SliderMatchesHot);
